<template>
  <modal
    name="newComponentModal"
    classes="wf-shadow-xl wf-bg-white wf-rounded-lg"
    @before-open="beforeOpen"
    @closed="closed"
  >
    <div class="wf-flex wf-flex-wrap wf-h-full">
      <div class="wf-w-1/3 wf-bg-blue-500 wf-overflow-scroll wf-max-h-full">
        <ul class="wf-max-h-full">
          <li v-for="(component) in components" :key="component.name">
            <a
              href="#"
              class="wf-bg-blue-500 wf-block hover:wf-bg-blue-700 wf-text-white wf-text-xs wf-uppercase wf-p-4 wf-border-b wf-border-blue-700"
              @click.prevent="selectedComponent = component"
            ><i class="fas wf-mr-2" :class="component.icon"></i>{{component.name}}</a>
          </li>
        </ul>
      </div>
      <div class="wf-w-2/3 wf-relative">
        <div class="wf-px-4 wf-py-2" v-if="selectedComponent">
          <h4 class="wf-uppercase wf-font-bold wf-text-xs wf-text-blue-700">Available Variations</h4>
          <div class="wf-flex wf-flex-wrap wf--mx-2 wf-mt-2">
            <div
              v-for="variation in selectedComponent.variations"
              class="wf-w-1/2 wf-px-2 wf-pb-2"
              :key="variation.name"
            >
              <button
                class="wf-border-2 wf-p-4 wf-relative wf-w-full wf-flex focus:wf-outline-none wf-items-center wf-justify-center wf-rounded-lg"
                :class="selectedVariation == variation.name ? 'wf-border-blue-500' : 'wf-border-gray-200'"
                @click.prevent="selectedVariation = variation.name"
              >
                <span
                  v-if="selectedVariation == variation.name"
                  class="wf-flex wf-absolute wf--mr-2 wf--mt-2 wf-items-center wf-justify-center wf-shadow wf-top-0 wf-right-0 wf-bg-blue-500 wf-h-5 wf-w-5 wf-text-white wf-rounded-full"
                ><i class="fas fa-check wf-text-xs"></i></span>
                <div v-html="variation.view"></div>
              </button>
            </div>
          </div>
          <button
            class="wf-absolute focus:wf-outline-none wf-bg-green-500 wf-bottom-0 wf-flex wf-h-12 wf-items-center wf-justify-center wf-mb-2 wf-mr-2 wf-right-0 wf-rounded-full wf-shadow wf-text-white wf-w-12"
            v-if="selectedVariation"
            @click.prevent="addComponent(selectedVariation)"
          ><i class="fas fa-plus wf-text-lg"></i></button>
        </div>
        <div v-else class="wf-p-4 wf-flex wf-items-center wf-justify-center">
          Add a component to your page
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  // import axios from 'axios'
  import { EditorComponentsBuilder } from '../EditorComponentsBuilder'
  import ArrayManipulation from '../mixins/ArrayManipulation'
  import {UuidGenerator} from '../UuidGenerator'
  export default {
    mixins: [ArrayManipulation],
    data() {
      return {
        components: [],
        layoutPageComponentIndex: null,
        sectionIndex: null,
        rowIndex: null,
        columnIndex: null,
        componentIndex: null,
        pageComponentIndex: null,
        componentSectionIndex: null,
        componentRowIndex: null,
        componentColumnIndex: null,
        selectedVariation: null,
        selectedComponent: null,
        innerComponent: false,
        layoutSectionComponent: false
      }
    },
    computed: {
      element() {
        return {
          layoutPageComponent: this.layoutPageComponentIndex,
          pageComponent: this.pageComponentIndex,
          section: this.sectionIndex,
          row: this.rowIndex,
          column: this.columnIndex,
          component: this.componentIndex,
          componentSection: this.componentSectionIndex,
          componentRow: this.componentRowIndex,
          componentColumn: this.componentColumnIndex
        }
      },
    },

    methods: {
      getComponents(innerComponent = false) {
        this.components = (new EditorComponentsBuilder(innerComponent)).get()
      },
      beforeOpen(event) {
        this.getComponents(event.params.innerComponent)
        this.sectionIndex = event.params.section
        this.rowIndex = event.params.row
        this.columnIndex = event.params.column
        this.componentIndex = event.params.component
        this.pageComponentIndex = event.params.pageComponent
        this.componentSectionIndex = event.params.componentSection
        this.componentColumnIndex = event.params.componentColumn
        this.componentRowIndex = event.params.componentRow
        this.componentColumnIndex = event.params.componentColumn
        this.innerComponent = event.params.innerComponent
        this.layoutSectionComponent = event.params.layoutSectionComponent
        this.parentModule = event.params.parentModule
        this.layoutPageComponentIndex = event.params.layoutPageComponent
      },
      closed() {
        this.selectedComponent = false
        this.components = []
        this.sectionIndex = null
        this.rowIndex = null
        this.columnIndex = null
        this.componentIndex = null
        this.pageComponentIndex = null
        this.componentSectionIndex = null
        this.componentColumnIndex = null
        this.componentRowIndex = null
        this.componentColumnIndex = null
        this.innerComponent = false
        this.layoutSectionComponent = false
        this.parentModule = null
      },
      addComponent(variation) {
        if (this.innerComponent) {
          this.handleInnerComponent(variation)
        }

        if (this.layoutSectionComponent) {
          this.handleLayoutSectionComponent(variation)
        }

        if (! this.innerComponent && ! this.layoutSectionComponent) {
          this.handleComponent(variation)
        }

        this.$modal.hide('newComponentModal')
      },

      handleLayoutSectionComponent(variation) {
        this.addToArray(
          'layoutColumnModule',
          [(new EditorComponentsBuilder).create(this.selectedComponent.name, variation)],
          'components',
          null,
          {},
          true,
          this.parentModule
        )
      },

      handleInnerComponent(variation) {
        this.addToArray(
          'componentColumnModule',
          [(new EditorComponentsBuilder).create(this.selectedComponent.name, variation)],
          'components',
          null,
          {},
          true,
          this.parentModule
        )
      },

      handleComponent(variation) {
        this.addToArray('columnModule', [(new EditorComponentsBuilder).create(this.selectedComponent.name, variation)], 'components')
      },

      newComponents(component, qty = 1) {
        let components = []
        for (let x = 0; x < qty; x++) {
          components.push({
            ...component,
            id: `component_${(new UuidGenerator).build()}`,
            slug: this.selectedComponent.slug,
            element: this.element
          })
        }
        return components
      },
    }
  }
</script>
